import {
  Award, Ban, BarChart3, BookOpen, Coins, Compass, Dices, Gavel, Gift, LifeBuoy, ShieldHalf, Wrench, LayoutDashboard, MessageSquare, Package, ScrollText,
  Gauge, Radio, Server, Settings, ShieldCheck, ShoppingCart, Terminal, UserCircle, Users, Zap,
} from "lucide-react";

export const NAV = [
  { group: "Command", items: [
    { path: "/overview", label: "Overview", icon: LayoutDashboard },
    { path: "/servers", label: "Servers", icon: Server },
    { path: "/server-tools", label: "Server Tools", icon: Gauge },
    { path: "/console", label: "Live Console", icon: Terminal },
    { path: "/discord", label: "Discord", icon: MessageSquare },
    { path: "/discord-tools", label: "Discord Tools", icon: Wrench },
    { path: "/tickets", label: "Tickets", icon: LifeBuoy },
  ] },
  { group: "Community", items: [
    { path: "/players", label: "Players", icon: Users },
    { path: "/moderation", label: "Moderation", icon: Gavel },
    { path: "/punishments", label: "Temp Bans & Prison", icon: Ban },
    { path: "/engagement", label: "Giveaways & Clans", icon: Gift },
    { path: "/feeds", label: "Feeds & Stats", icon: Radio },
    { path: "/economy", label: "Economy", icon: Coins },
    { path: "/battlepass", label: "Battle Pass", icon: Award },
    { path: "/casino", label: "Casino", icon: Dices },
    { path: "/shop", label: "Shop", icon: ShoppingCart },
    { path: "/kits", label: "Kits", icon: Package },
  ] },
  { group: "Gameplay", items: [
    { path: "/teleports", label: "Teleports", icon: Compass },
    { path: "/protection", label: "Protection & TP", icon: ShieldHalf },
    { path: "/events", label: "Events", icon: Zap },
    { path: "/rules", label: "PvP / PvE Rules", icon: BookOpen },
  ] },
  { group: "System", items: [
    { path: "/analytics", label: "Analytics", icon: BarChart3 },
    { path: "/settings", label: "Settings", icon: Settings },
    { path: "/audit", label: "Audit Logs", icon: ScrollText },
    { path: "/system", label: "System", icon: ShieldCheck, ownerOnly: true },
    { path: "/portal", label: "Player Portal", icon: UserCircle },
  ] },
];
